import React from "react";
import "./WhyLoveIt.css";

const features = [
    {
        icon: "link",
        title: "Precision needle tip",
        description: "Ultra-fine needle dispenser for pinpoint accuracy on micro repairs.",
    },
    {
        icon: "grid",
        title: "Multi-surface bond",
        description: "Bonds glass, metal, plastics, leather, wood, acrylic and ceramics.",
    },
    {
        icon: "layers",
        title: "100% Waterproof",
        description: "Fully waterproof and weather-resistant once cured.",
    },
    {
        icon: "box",
        title: "Crystal clear finish",
        description: "Dries completely transparent with zero residue or yellowing.",
    },
    {
        icon: "stack",
        title: "High elasticity",
        description: "Shock-resistant flexible bond that withstands impacts and vibration.",
    },
    {
        icon: "check",
        title: "Anti-clogging pin cap",
        description: "Built-in cap pin ensures the nozzle never clogs or dries out.",
    },
];

const FeatureIcon = ({ type }) => {
    if (type === "link") {
        return (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M10.2 13.8a4 4 0 0 0 5.7 0l2-2a4 4 0 0 0-5.7-5.7l-1.1 1.1" />
                <path d="M13.8 10.2a4 4 0 0 0-5.7 0l-2 2a4 4 0 0 0 5.7 5.7l1.1-1.1" />
            </svg>
        );
    }

    if (type === "grid") {
        return (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <rect x="4" y="4" width="6" height="6" rx="1" />
                <rect x="14" y="4" width="6" height="6" rx="1" />
                <rect x="4" y="14" width="6" height="6" rx="1" />
                <rect x="14" y="14" width="6" height="6" rx="1" />
            </svg>
        );
    }

    if (type === "layers") {
        return (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="m4 8 8-4 8 4-8 4-8-4Z" />
                <path d="m4 12 8 4 8-4" />
                <path d="m4 16 8 4 8-4" />
            </svg>
        );
    }

    if (type === "box") {
        return (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="m4 7 8-4 8 4v10l-8 4-8-4V7Z" />
                <path d="m4 7 8 4 8-4" />
                <path d="M12 11v10" />
            </svg>
        );
    }

    if (type === "stack") {
        return (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <rect x="6" y="5" width="12" height="5" rx="1" />
                <path d="M5 12h14" />
                <path d="M7 12v7h10v-7" />
            </svg>
        );
    }

    return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="m5 12 4 4L19 6" />
        </svg>
    );
};

const WhyLoveIt = () => {
    return (
        <section className="hm-why-love">

            <div className="hm-why-love-container">

                {/* LEFT IMAGE */}
                <div className="hm-why-image-wrapper">
                    <img
                        src="/images/Why.webp"
                        alt="MultiFct multi-purpose adhesive"
                        className="hm-why-image"
                    />
                </div>


                {/* RIGHT CONTENT */}
                <div className="hm-why-content">

                    <span className="hm-why-label">
                        WHY YOU'LL LOVE IT
                    </span>

                    <h2>
                        Every detail, considered
                    </h2>

                    <p className="hm-why-intro">
                        From precision needle dispensing to extreme bond strength,
                        MultiFct is built to make repairs effortless and reliable.
                    </p>


                    {/* FEATURES */}
                    <div className="hm-features">

                        {features.map((feature, index) => (
                            <div
                                className="hm-feature"
                                key={index}
                            >

                                <div className="hm-feature-icon">
                                    <FeatureIcon type={feature.icon} />
                                </div>

                                <div className="hm-feature-content">

                                    <h3>
                                        {feature.title}
                                    </h3>

                                    <p>
                                        {feature.description}
                                    </p>

                                </div>

                            </div>
                        ))}

                    </div>

                </div>

            </div>

        </section>
    );
};

export default WhyLoveIt;